import { defineRecipe } from '@chakra-ui/react';

/** Visibility badges. Palette still comes from the visibility label. */
export const badgeRecipe = defineRecipe({
  base: {
    flexShrink: 0,
  },
});
